import { useSnackBar } from 'hooks/useSnackBar'
import { useSelector } from 'react-redux'

export const SnackBar = () => {
  const alertas = useSelector((state) => state.alertas)
  const snack = {
    message: alertas.message,
    variant: alertas.variant,
  }

  const snackBar = useSnackBar()

  return snackBar(snack)
}
